import { flushSync } from 'react-dom';

// React 18 schedules createRoot().render(). Turbolinks can paint its new, empty
// React containers before that work runs. Commit in the render event itself,
// including cached previews (which do not emit turbolinks:load).
export default function installNavigationLifecycle(ujs) {
  const mountComponents = ujs.mountComponents;
  ujs.mountComponents = function (...args) {
    flushSync(() => mountComponents.apply(this, args));
  };

  document.addEventListener('turbolinks:render', ujs.handleMount);

  // The cache has already copied the outgoing DOM by before-render. Unmount
  // now so detached pages stop their polling, timers and document listeners.
  document.addEventListener('turbolinks:before-render', () => {
    Array.from(ujs.findDOMNodes()).forEach(node => {
      if (!node.closest('[data-turbolinks-permanent]')) {
        ujs.unmountRoot(node);
      }
    });
  });
}
